import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton
} from '@mui/material';
import editPenImg from '../../assets/images/CustomerManagement/edit-pen-img.svg';
import SbCancelBtn, { SbAddBtn, SBSaveUpdateBtn } from '../Buttons/Buttons';
import calendar from '../../assets/images/Dashboard/calendar-icon.svg';
import searchIcon from '../../assets/images/Dashboard/search-icon.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import AddLeave from './AddLeave';
import Main from '../Main';
import customerImg from '../../assets/images/CustomerManagement/customer-img.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import Download from '../MainSection/Download/Download';
import PaginationComponent from '../PaginationComponent';
import { useDispatch, useSelector } from 'react-redux';
import { loadSingleLeaveBalanceData, loadSingleLeaveData, loadSingleUserManagementData, postUpdateLeaveDatas } from '../../redux/action';
import { Typeahead } from 'react-bootstrap-typeahead';
import moment from 'moment';
import noModuleAccess from '../../assets/images/no-module-access.svg';
import attachment from '../../assets/images/Dashboard/attachment-download-img.svg';
import { Pointer } from 'highcharts';
import { ADDED_BY_ID } from '../../Constants';
import * as HeaderAuthentication from '../HeaderAuthentication'
import SbComplaintStatusDropdown from '../Buttons/SbComplaintStatusDropdown';
import noDataFound from '../../assets/images/no-data-found.svg';
import Skeleton from 'react-loading-skeleton';
import { formatDate } from '../DateTimeUtils';
import view from '../../assets/images/Dashboard/view-img.svg';

// Table columns
const columns = [
    { id: 'StartDate', label: 'FROM DATE', align: 'left', minWidth: '180px' },
    { id: 'EndDate', label: 'TO DATE', align: 'left', minWidth: '180px' },
    { id: 'LeaveDuration', label: 'LEAVE DURATION', align: 'left', minWidth: '150px' },
    { id: 'ReportingTo', label: 'REPORTING TO', align: 'left', minWidth: '150px' },
    { id: 'LeaveTypeName', label: 'LEAVE TYPE', align: 'left', minWidth: '150px' },
    { id: 'Reason', label: 'REASON', align: 'left', minWidth: '150px' },
    { id: 'Status', label: 'STATUS', align: 'left', minWidth: '150px' },
    { id: 'Action', label: 'Action', align: 'left', minWidth: '80px' },
];

const LeaveDetailsForUser = ({ signInUserId, handleOpenModal, handleOpenUserLeaveModal, leavesData, handleOpen, setDataLoading }) => {

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

    const navigate = useNavigate();
    const dispatch = useDispatch();
    let location = useLocation();

    const moduleId = location.state?.moduleId;

    const [openAddLeave, setAddLeave] = useState(false);
    const { singleUserData } = useSelector((state) => state.data);
    const { singleLeaveBalanceData = [] } = useSelector((state) => state.data);
    const { totalDataCount } = useSelector((state) => state.data);
    const { singleLeaveData = [] } = useSelector((state) => state.data);

    const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];

    // Pagination state
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10); // Set initial rows per page
    const [paginatedData, setPaginatedData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [fromDate, setFromDate] = useState(moment().startOf("year").format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(moment().endOf("year").format("YYYY-MM-DD"));
    const [selected, setSelected] = useState([]);
    const [moduleData, setModuleData] = useState(null);
    const [showCancelModal, setShowCancelModal] = useState(false);

    useEffect(() => {
        if (moduleId && storedModulePermissions.length) {
            // Loop through storedModulePermissions and nested MainModules and SubModules to find the matching ModuleID
            let foundModule = null;

            outerLoop:
            for (const sidebarMenu of storedModulePermissions) {
                for (const mainModule of sidebarMenu.MainModules) {
                    if (mainModule.SubModules && mainModule.SubModules.length > 0) {
                        const subModule = mainModule.SubModules.find(sub => sub.ModuleID === moduleId);
                        if (subModule) {
                            foundModule = subModule;
                            break outerLoop;
                        }
                    }
                }
            }

            setModuleData(foundModule);
        }
    }, [storedModulePermissions, moduleId]);

    const handleAddLeave = () => {
        setAddLeave(true);
    };

    const handleCloseAddLeave = () => {
        setAddLeave(false);
    };

    const handleEditLeave = () => {
        setAddLeave(true);
    };

    const handleAnalyticsClick = () => {
        navigate('/attendanceDashboard')
    }

    const handleBack = () => {
        navigate(-1);
    };

    // Pagination logic
    useEffect(() => {
        if (!Array.isArray(singleLeaveData) || singleLeaveData.length === 0) {
            console.warn("⚠️ No Leave Data Found or Data is Not an Array!", singleLeaveData);
            setPaginatedData([]);
            return;
        }

        // Calculate pagination
        const maxPage = Math.ceil(singleLeaveData.length / rowsPerPage);
        const newPage = Math.min(page, maxPage - 1); // Prevents out-of-range pages

        const start = newPage * rowsPerPage;
        const end = start + rowsPerPage;
        const paginated = singleLeaveData.slice(start, end);

        // Only update state if paginated data has changed
        setPaginatedData(prev => JSON.stringify(prev) === JSON.stringify(paginated) ? prev : paginated);
    }, [singleLeaveData.length, page, rowsPerPage]);


    const handlePageChange = (newPage) => {
        setPage(newPage - 1); // Handle 1-based to 0-based page index for slicing
    };
    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0); // Reset to the first page when rows per page changes
    };

    useEffect(() => {
        if (signInUserId) {
            dispatch(loadSingleUserManagementData(signInUserId, setDataLoading));
            dispatch(loadSingleLeaveBalanceData(signInUserId, fromDate, toDate));
        }
    }, [signInUserId, fromDate, toDate, dispatch]);

    const fetchSingleLeaveData = () => {
        dispatch(loadSingleLeaveData(setLoading, rowsPerPage, page + 1, searchQuery, fromDate, toDate, "", signInUserId));
    };

    // Call the function inside useEffect
    useEffect(() => {
        if (signInUserId) {
            fetchSingleLeaveData();
        }
    }, [page + 1, searchQuery, fromDate, toDate]);

    const [subordinateView, setSubordinateView] = useState(false);

    const fetchSubOrdinatesData = () => {
        if (signInUserId) {
            console.log(signInUserId, 'signInUserId')
            dispatch(loadSingleLeaveData(setLoading, rowsPerPage, page + 1, searchQuery, fromDate, toDate, "", "", signInUserId));
        }
    };

    // Call API when subordinateView is enabled
    useEffect(() => {
        // if (
        //     signInDetails?.length > 0 &&
        //     signInDetails[0]?.SignInType === "User" &&
        //     signInDetails[0]?.HasSubordinates === "Yes" &&
        //     subordinateView
        // ) {
        //     fetchSubOrdinatesData();
        // }
        if (
            signInDetails?.length > 0 &&
            signInDetails[0]?.SignInType === "User"
        ) {
            if (subordinateView && signInDetails[0]?.HasSubordinates === "Yes") {
                fetchSubOrdinatesData();
            } else {
                fetchSingleLeaveData();
            }
        }
    }, [rowsPerPage, page + 1, searchQuery, fromDate, toDate, '', "", signInUserId, subordinateView, dispatch]);

    // Handle the search input change (when selecting an item from Typeahead)
    const handleSearchChange = (selected) => {
        const query = selected.length ? selected[0] : ''; // Get the selected query or an empty string
        setSearchQuery(query); // Update searchQuery
        setSearchText(query); // Update searchText
        setSelected(selected);
    };

    const handleClearFilters = () => {
        setSearchText("");
        setSearchQuery("");
        setFromDate(moment().startOf("year").format("YYYY-MM-DD"));
        setToDate(moment().endOf("year").format("YYYY-MM-DD"));
        setSelected([]);
        // fetchSingleLeaveData();
    }

    // Step 1: Group leave data by LeaveTypeName
    const groupedLeaveTypes = {};

    if (Array.isArray(singleLeaveBalanceData)) {
        singleLeaveBalanceData.forEach((item) => {
            const fromMonth = item.StartDate
                ? new Date(item.StartDate).toLocaleString('en-US', { month: 'short' })
                : '';
            const toMonth = item.EndDate
                ? new Date(item.EndDate).toLocaleString('en-US', { month: 'short' })
                : '';
            const period = `${fromMonth} - ${toMonth}`;

            if (Array.isArray(item.LeaveBalanceDays)) {
                item.LeaveBalanceDays.forEach((leave) => {
                    const type = leave.LeaveTypeName;

                    if (!groupedLeaveTypes[type]) {
                        groupedLeaveTypes[type] = [];
                    }

                    groupedLeaveTypes[type].push({
                        period,
                        NoofDaysAvailable: leave.NoofDaysAvailable,
                        NoofDaysAvailed: leave.NoofDaysAvailed,
                    });
                });
            }
        });
    }

    const [selectedRow, setSelectedRow] = useState(null);
    const handleOpenCancelModal = (row) => {
        setSelectedRow(row);
        setShowCancelModal(true);
    };

    const handleConfirmCancel = () => {
        if (selectedRow) {
            handleCancelLeave(selectedRow);
        }
        setShowCancelModal(false);
    };

    const handleCloseModal = () => {
        setShowCancelModal(false);
    };

    const handleCancelLeave = (customer) => {

        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;

        // Check the SignInType and assign appropriate IDs and CompanyCode
        if (signInDetails[0]?.SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0]?.SuperAdminID; // Assuming SuperAdminID is available in SignInDetails
        } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for ClientAdmin
        } else if (signInDetails[0]?.SignInType === "User") {
            CustomerID = signInDetails[0]?.UserID; // Use UserID for User type
        }

        const todayDate = new Date().toISOString().split('T')[0]; // "YYYY-MM-DD" format
        // console.log("🚀 Updating Status:", { customer, statusLabel, statusID });

        const data = {
            LeaveID: customer.LeaveID,
            StatusID: 61,
            Message: "Cancelled",
            UpdatedByID: CustomerID,
            UpdatedOn: todayDate,
            AddedByID: ADDED_BY_ID
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        dispatch(postUpdateLeaveDatas(requestOption, handleCloseModal, leavesData));
        // console.log(data, 'data')
    };

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Leaves Details"
                        showDashboardLibraryButton={false}
                        showSaveCustomViewButton={false}
                        showAnalyticsButton={true}
                        showDownloadDropdown={true}
                        onClick={handleAnalyticsClick}
                        onBackClick={handleBack}
                    />
                </div>

                {/* <div className="customermanagement-content"> */}
                {/* <Row className='leaves-cards-container'>
                    {singleLeaveBalanceData[0]?.LeaveBalanceDays?.map((leave, index) => (
                        <Col key={index} md={2} className='leave-cards leave-details-card'>
                            <div className='leave-cards-counts'>
                                <b>{leave.NoofDaysAvailed}</b>
                                <p>{leave.LeaveTypeName}</p>
                            </div>
                        </Col>
                    ))}
                    <Col md={2} className='leave-cards leave-details-card'>
                        <div className='leave-cards-counts'>
                            <b style={{ height: "60px", width: "60px", margin: "0px" }}>
                                {singleLeaveBalanceData[0]?.LeaveBalanceDays
                                    ? `${singleLeaveBalanceData[0]?.LeaveBalanceDays.reduce((acc, leave) => acc + leave.NoofDaysAvailed, 0)} / 
                                   ${singleLeaveBalanceData[0]?.LeaveBalanceDays.reduce((acc, leave) => acc + leave.NoofDaysAllotted, 0)}`
                                    : "0 / 0"}
                            </b>
                            <p style={{ margin: "0px" }}>Total Leave Balance</p>
                        </div>
                    </Col>
                </Row> */}
                <Row className='leaves-cards-container'>
                    {Object.entries(groupedLeaveTypes).map(([leaveType, periods], index) => (
                        <Col key={index} md={3} className='leave-cards leave-details-card mb-3 overflow-auto justify-content-start w-100 p-0'>
                            <div className='p-2 h-100 w-100 d-flex flex-column justify-content-between'>
                                <div>
                                    <p className='mb-2 text-center fw-semibold'>{leaveType}</p>
                                    {/* <hr className='my-1' /> */}
                                    <div className='leave-period-div'>
                                        {periods.map((entry, i) => (
                                            <div key={i} className='user-leave-period-count-div'>
                                                <p>
                                                    <b className='period'>{entry.period}</b> <div className='user-leave-cards-counts'><b>{entry.NoofDaysAvailable}</b> / <b>{entry.NoofDaysAvailed}</b></div>
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
                <Row className='m-0 employee-leaves-details-container'>
                    <Col md={9} className='customermanagement-search-filter p-0'>
                        <div className='customermanagement-content-container'>
                            <div className="customermanagement-content">
                                <Row className='customermanagement-btns-container'>
                                    <Col md={3} className='customermanagement-backbtn-div'>
                                        <span>{[singleUserData[0]?.FirstName, singleUserData[0]?.MiddleName, singleUserData[0]?.LastName].filter(Boolean).join(" ")}</span>
                                    </Col>
                                    <Col md={9} className='customermanagement-search-filter'>
                                        {/* <Row> */}
                                        <Col md={5} className='filters-col'>
                                            <div className='customermanagement-search'>
                                                {/* <Form.Control type="search" placeholder='Search' /> */}
                                                <Typeahead
                                                    id="search-typeahead"
                                                    onChange={handleSearchChange}
                                                    options={
                                                        Array.isArray(singleLeaveData)
                                                            ? [...new Set(singleLeaveData.map(leave => leave.LeaveTypeName).filter(Boolean))]
                                                            : []
                                                    }
                                                    labelKey={(option) => option} // We are using a string (the company name), so we just use the string directly
                                                    placeholder="Search Leave Type"
                                                    value={searchText}
                                                    onInputChange={(input) => setSearchText(input)} // Update searchText with typed value
                                                    minLength={1} // Minimum characters before suggestions appear
                                                    autoFocus={false} // Prevent auto focusing on input
                                                    selected={selected}
                                                />
                                                <img src={searchIcon} alt="Search" />
                                            </div>
                                        </Col>
                                        <Col md={3} className='filters-col'>
                                            <div className='calendar-container'>
                                                <DatePicker
                                                    className="select from-date"
                                                    id="date-range-picker-from"
                                                    dateFormat="dd/MM/yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    // selectsRange
                                                    dropdownMode="select"
                                                    placeholderText='From'
                                                    maxDate={new Date()}
                                                    selected={fromDate}
                                                    onChange={(date) => setFromDate(date)}
                                                    onChangeRaw={e => e.preventDefault()}
                                                />
                                                <img src={calendar} alt="Calendar" />
                                            </div>
                                        </Col>
                                        <Col md={3} className='filters-col'>
                                            <div className='calendar-container'>
                                                <DatePicker
                                                    className="select from-date"
                                                    id="date-range-picker-to"
                                                    dateFormat="dd/MM/yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    // selectsRange
                                                    dropdownMode="select"
                                                    placeholderText='To'
                                                    minDate={new Date()}
                                                    selected={toDate}
                                                    onChange={(date) => setToDate(date)}
                                                    onChangeRaw={e => e.preventDefault()}
                                                />
                                                <img src={calendar} alt="Calendar" />
                                            </div>
                                        </Col>
                                        {/* </Row> */}
                                        {/* <SbAddBtn btnName="Add Leaves" onClickEffect={handleAddLeave} /> */}
                                        <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                        {moduleData?.CanCreate === true && <SbAddBtn btnName="Apply Leaves" onClickEffect={handleOpenUserLeaveModal} />}
                                        <div className='leave-view-img-div'>
                                            <img src={view} alt="View"
                                                onClick={handleOpen}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row >
                                    <Col md={4}>
                                        {signInDetails?.length > 0 &&
                                            signInDetails[0]?.SignInType === "User" &&
                                            signInDetails[0]?.HasSubordinates === "Yes" && (
                                                <Form.Check
                                                    type="switch"
                                                    id="subordinate-toggle"
                                                    label="My Subordinates"
                                                    checked={subordinateView}
                                                    onChange={() => setSubordinateView(!subordinateView)}
                                                // className="ms-3"
                                                />
                                            )
                                        }
                                    </Col>
                                </Row>

                                {moduleData?.CanView === true ? (
                                    <div className='customermanagement-table-div leave-details-table'>
                                        <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        {columns.map((column) => (
                                                            <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                                                <div style={{ display: 'flex', alignItems: 'center' }} className='table-header-div'>
                                                                    {column.label}
                                                                </div>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>
                                                {/* <TableBody>
                                                    {paginatedData.map((row, index) => (
                                                        <TableRow key={index} className='table-row-data-container'>
                                                            {columns.map((column) => (
                                                                // <TableCell key={column.id} align={column.align}>
                                                                //     {row[column.id]}
                                                                // </TableCell>

                                                                <TableCell key={column.id} align={column.align}>
                                                                    {column.id === "Action" ? (
                                                                        row.FilePath ? (
                                                                            <img
                                                                                src={attachment}
                                                                                alt="Download"
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={async () => {
                                                                                    try {
                                                                                        const response = await fetch(row.FilePath, { mode: "cors" });
                                                                                        const blob = await response.blob();
                                                                                        const url = window.URL.createObjectURL(blob);

                                                                                        const link = document.createElement("a");
                                                                                        link.href = url;
                                                                                        link.download = row.FileName || "leave-document";
                                                                                        document.body.appendChild(link);
                                                                                        link.click();
                                                                                        document.body.removeChild(link);

                                                                                        window.URL.revokeObjectURL(url);
                                                                                    } catch (error) {
                                                                                        console.error("Download failed:", error);
                                                                                    }
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <span>No File</span>
                                                                        )
                                                                    ) : (
                                                                        row[column.id]
                                                                    )}
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    ))}
                                                </TableBody> */}

                                                <TableBody>
                                                    {loading ? (
                                                        [...Array(rowsPerPage)].map((_, index) => (
                                                            <TableRow key={index}>
                                                                {columns.map((column) => (
                                                                    <TableCell key={column.id} align={column.align}>
                                                                        <Skeleton height={40} />
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        ))
                                                    ) : paginatedData.length === 0 ? (
                                                        // Display "No Data Found" row if no data is present in the paginated data
                                                        <TableRow>
                                                            <TableCell colSpan={columns.length}>
                                                                <img src={noDataFound} alt="" style={{ height: "250px", width: "280px" }} />
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : (
                                                        paginatedData.map((row, index) => (
                                                            <TableRow key={index} className='table-row-data-container'>
                                                                {columns.map((column) => (
                                                                    <TableCell key={column.id} align={column.align}>
                                                                        {column.id === "Action" ? (
                                                                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                                                                {row.FilePath ? (
                                                                                    <img
                                                                                        src={attachment}
                                                                                        alt="Download"
                                                                                        className="download-image"
                                                                                        data-toggle="tooltip" data-placement="right" title="Download"
                                                                                        style={{ cursor: "pointer" }}
                                                                                        onClick={async () => {
                                                                                            try {
                                                                                                const response = await fetch(row.FilePath, { mode: "cors" });
                                                                                                const blob = await response.blob();
                                                                                                const url = window.URL.createObjectURL(blob);

                                                                                                const link = document.createElement("a");
                                                                                                link.href = url;
                                                                                                link.download = row.FileName || "leave-document";
                                                                                                document.body.appendChild(link);
                                                                                                link.click();
                                                                                                document.body.removeChild(link);

                                                                                                window.URL.revokeObjectURL(url);
                                                                                            } catch (error) {
                                                                                                console.error("Download failed:", error);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                ) : (
                                                                                    <span>No File</span>
                                                                                )}
                                                                                {row.StatusID !== 59 && row.StatusID !== 60 && (
                                                                                    // <SbCancelBtn
                                                                                    //     btnName="Cancel"
                                                                                    //     onClickEffect={() => handleOpenCancelModal(row, "Cancelled")}
                                                                                    // />
                                                                                    <button className="leave-cancel-btn" onClick={() => handleOpenCancelModal(row, "Cancelled")} >
                                                                                        Cancel
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        ) : column.id === "Status" ? (
                                                                            // <SbComplaintStatusDropdown status={row.Status} />
                                                                            <span
                                                                                className={`status-badge ${row.Status === 'Approved'
                                                                                    ? 'complete-status no-dropdown-badge'
                                                                                    : row.Status === 'Pending'
                                                                                        ? 'pending-status no-dropdown-badge'
                                                                                        : 'cancel-status no-dropdown-badge'
                                                                                    }`}
                                                                            >
                                                                                {row.Status}
                                                                            </span>
                                                                        ) : column.id === 'StartDate' ? (
                                                                            formatDate(row[column.id]) // Format the Date field
                                                                        ) : column.id === 'EndDate' ? (
                                                                            formatDate(row[column.id])
                                                                        ) : (
                                                                            row[column.id]
                                                                        )}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        )))}
                                                </TableBody>

                                            </Table>
                                        </TableContainer>
                                        {/* Use PaginationComponent */}
                                        <PaginationComponent
                                            totalItems={totalDataCount}
                                            itemsPerPage={rowsPerPage}
                                            onPageChange={handlePageChange}
                                            onRowsPerPageChange={handleRowsPerPageChange}
                                        />
                                    </div>
                                ) : (
                                    <div className='d-flex align-items-center justify-content-center p-3'>
                                        <img src={noModuleAccess} alt="" />
                                    </div>
                                )}
                            </div>
                        </div>
                    </Col>

                    <Col md={3} className='employee-profile-col'>
                        {/* Employee Profile Section */}
                        <div className="employee-profile-container">
                            <img src={customerImg} alt="Profile" className="employee-profile-img" />
                            <div className="employee-details">
                                <div className='pb-3'>
                                    <p>ID</p>
                                    <span>{singleUserData[0]?.UserID}</span>
                                </div>
                                <div className='pb-3'>
                                    <p>Name</p>
                                    <span><span>{[singleUserData[0]?.FirstName, singleUserData[0]?.MiddleName, singleUserData[0]?.LastName].filter(Boolean).join(" ")}</span>                                    </span>
                                </div>
                                <div className='pb-3'>
                                    <p>Email </p>
                                    <span>{singleUserData[0]?.EmailID}</span>
                                </div>
                                <div className='pb-3'>
                                    <p>Role </p>
                                    <span>{singleUserData[0]?.UserRoles?.map(role => role.RoleName).join(", ")}</span>
                                </div>
                                <div className='pb-3'>
                                    <p>Department </p>
                                    <span>{singleUserData[0]?.DepartmentName}</span>
                                </div>
                                <div className='pb-3'>
                                    <p>Contact </p>
                                    <span>{singleUserData[0]?.Phone}</span>
                                </div>
                                <div className='pb-3'>
                                    <p>Address</p>
                                    <span> {singleUserData[0]?.WorkAddress}</span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Cancel Confirmation Modal */}
                <Modal className='sw-modal' show={showCancelModal} onHide={handleCloseModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Cancellation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p> Are you sure you want to cancel this leave request?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <SbCancelBtn btnName="No" onClickEffect={handleCloseModal} />
                        <SBSaveUpdateBtn btnName="Yes" onClickEffect={handleConfirmCancel} />
                    </Modal.Footer>
                </Modal>
            </Main >
        </div>
    );
};

export default LeaveDetailsForUser;
